import React, { FC, useMemo } from 'react'
import Touchable from '@sport1/react-elements/Touchable'
import Grid from '@sport1/react-elements/Grid'
import { CompetitorProps } from '../../MatchTypes'
import LinkProps from '../../../../Link/LinkProps'
import BaseMatchCompetitor from './BaseMatchCompetitor'

export type MatchCompetitorProps = CompetitorProps &
    LinkProps & {
        type: 'home' | 'away'
        textPaddingLeft?: number | number[]
        textPaddingRight?: number | number[]
    }

const MatchCompetitor: FC<MatchCompetitorProps> = ({ onPress, href, webRel, ...rest }) => {
    const competitor = useMemo(() => <BaseMatchCompetitor {...rest} />, [rest])
    return onPress || href ? (
        <Grid minWidth={0}>
            <Touchable href={href} onPress={onPress} webRel={webRel}>
                <Grid noExpand horizontal centerVertical>
                    {competitor}
                </Grid>
            </Touchable>
        </Grid>
    ) : (
        competitor
    )
}

export default MatchCompetitor
